module.exports = __webpack_public_path__ + "img/GREENN_SALES_WHITE.e151f458.png";